import { Route } from '@angular/router';
import { APP_ROUTE_PATHS } from '@ps/core-config';
import { legacyUnderConstruction } from './utils/under-construction.helper';

/**
 * Matches `APP_ROUTES.OPERATOR_ROUTES`.
 * Wrapped in `AUTHENTICATED_APP_ROUTES` under a `roleGuard` group with `roles: ['operator']`.
 * Routes requiring sub-level access carry their own `canActivate: [roleGuard]` + `accessLevel`.
 */
export const OPERATOR_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.manageCompanies,
    loadComponent: () =>
      import('../pages/company/manage-companies/manage-companies.page').then(
        (m) => m.ManageCompaniesPage,
      ),
    title: 'Manage Companies',
  },
  legacyUnderConstruction(APP_ROUTE_PATHS.manageUsers, '/manage-users'),
  {
    path: APP_ROUTE_PATHS.operatorSettings,
    loadComponent: () =>
      import('../pages/operator-settings/operator-settings.page').then(
        (m) => m.OperatorSettingsPage,
      ),
    title: 'Operator Settings',
  },
  {
    path: APP_ROUTE_PATHS.reportsDashboard,
    loadComponent: () =>
      import('../pages/report/reports-dashboard/reports-dashboard.page').then(
        (m) => m.ReportsDashboardPage,
      ),
    title: 'Reports Dashboard',
  },
  legacyUnderConstruction(APP_ROUTE_PATHS.adjustments, '/adjustments'),
];
